import { isEmpty, find } from "lodash";
const devLogConsole = require("~/utils/devLog");
export const generateTreeMenu = (menu) => {
  if (isEmpty(menu)) return [];
  const treeMenu = {};
  menu.forEach(item => {
    if (item && item?.childrens && item?.childrens.length > 0) {
      item.childrens.map((child) => {
        if(child && child.submenu === true && item.menuParent === null){
          item.childrens = item.childrens.filter((child) => typeof child.menuParent !== "string");
        }
      });
    }
    if (treeMenu[item.id] && treeMenu[item.id].childrens) {
      item.childrens = treeMenu[item.id] && treeMenu[item.id].childrens;
    }
    treeMenu[item.id] = item;
    treeMenu[item.menuParent] = treeMenu[item.menuParent] || {};
    treeMenu[item.menuParent].childrens = treeMenu[item.menuParent].childrens || [];
    if (!find(treeMenu[item.menuParent].childrens, { name: item.name })) {
      treeMenu[item.menuParent].childrens.push(item);
    }
  });
  //devLogConsole(treeMenu.null.childrens);
  return treeMenu.null.childrens;
}
